import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "footer-list-kulioner",
  class: "absolute bottom-0 w-full border border-red left-0 py-3 px-6 bg-white footer-shadow",
  style: {"z-index":"29"}
}
const _hoisted_2 = { class: "flex flex-row justify-between items-center gap-4" }
const _hoisted_3 = { class: "flex flex-row gap-4 items-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "text-black-lp-100 font-bold" }, "Total harga", -1)
const _hoisted_5 = { class: "text-red-lp-100 font-semibold" }
const _hoisted_6 = { class: "pl-4 border-l border-gray-lp-200" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "text-black-lp-100 font-bold" }, "Total merchant", -1)
const _hoisted_8 = { class: "text-green-lp-400 font-semibold" }
const _hoisted_9 = { class: "flex flex-row items-center gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalProcessKulioner = _resolveComponent("ModalProcessKulioner")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("section", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", null, [
            _hoisted_4,
            _createVNode("p", _hoisted_5, _toDisplayString(_ctx.totalPrice), 1)
          ]),
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("p", _hoisted_8, _toDisplayString(_ctx.totalMerchant), 1)
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          (_ctx.isShowPrintReceipt)
            ? (_openBlock(), _createBlock(_component_LpButton, {
                key: 0,
                id: "button_bulk_print_receipt_list_kulioner",
                title: "Print resi",
                color: "white",
                textColor: "gray-lp-300",
                textSize: "14",
                iconGroupHoverColor: "gray-lp-300",
                iconColor: _ctx.isLoadingDownloadOrder ? 'gray-lp-600' : 'gray-lp-300',
                customClass: "underline",
                iconLeft: "printer-black",
                sizeIcon: "24px",
                small: "",
                disabled: _ctx.isLoadingPrintReceipt,
                onClick: _ctx.onPrintReceipt
              }, null, 8, ["iconColor", "disabled", "onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_LpButton, {
            id: "button_bulk_print_order_list_kulioner",
            title: "Download pesanan",
            color: "white",
            textColor: "gray-lp-300",
            customClass: "underline",
            iconGroupHoverColor: "gray-lp-300",
            iconLeft: "download-new",
            iconColor: _ctx.isLoadingDownloadOrder ? 'gray-lp-600' : 'gray-lp-300',
            sizeIcon: "18px",
            iconV2: "",
            textSize: "14",
            small: "",
            disabled: _ctx.isLoadingDownloadOrder,
            onClick: _ctx.onPrintOrder
          }, null, 8, ["iconColor", "disabled", "onClick"]),
          (_ctx.isShowAcceptOrder)
            ? (_openBlock(), _createBlock(_component_LpButton, {
                key: 1,
                id: "button_bulk_accept_order_list_kulioner",
                title: _ctx.acceptOrderButtonText,
                textColor: "white",
                textSize: "12",
                onClick: _ctx.onAcceptOrder
              }, null, 8, ["title", "onClick"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_ModalProcessKulioner, {
      id: "modal-confirm-accept-order",
      modelValue: _ctx.isOpenConfirmOrderModal,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpenConfirmOrderModal = $event)),
      data: _ctx.selected,
      onRefetch: _cache[2] || (_cache[2] = () => _ctx.$emit('refetch')),
      onSuccess: _cache[3] || (_cache[3] = () => _ctx.isOpenConfirmOrderModal = false),
      onFailed: _cache[4] || (_cache[4] = () => _ctx.isOpenConfirmOrderModal = false)
    }, null, 8, ["modelValue", "data"])
  ], 64))
}